mtl.alloy.factory['ajax'] = (function($) {
    'use strict';

    return function(element, options) {
        $(element).on('click', function(e){
            e.preventDefault();

            $.ajax({
                url: $(this).attr('href'),
                cache: false,
                success: function(jsonContent){
                    if(jsonContent.item === true) {
                        if(!$(element).hasClass('active') && $(element).hasClass('wishlist'))
                        {
                            var $wishlistBtn = $('.total', '.layout-header__wishlist-btn');
                            $wishlistBtn.text(parseInt($wishlistBtn.text()) + 1);
                        }
                        $(element).addClass('active');
                    } else {
                        $(element).removeClass('active');
                    }
                },
            });
        });
    }

}($));
